export const newsletterByEmailFromJSON = (json: INewsletterByEmail): INewsletterByEmailModel => {
	const { client_id, has_client_account, newsletter_marketing_consent, topics, ...rest } = json

	return {
		...toCamelCase(rest),
		clientID: client_id,
		hasClientAccount: has_client_account,
		newsletterMarketingConsent: newsletter_marketing_consent,
		topics,
	}
}

export const newsletterDeleteResultFromJSON = (json: INewsletterDeleteResult): INewsletterDeleteResultModel => {
	const { client_id, has_client_account, newsletter_removed, cio_profile_deleted, topics, ...rest } = json

	return {
		...toCamelCase(rest),
		clientID: client_id,
		hasClientAccount: has_client_account,
		newsletterRemoved: newsletter_removed,
		cioProfileDeleted: cio_profile_deleted,
		topics,
	}
}

export const newsletterSubscriberFromJSON = (json: INewsletterSubscriber): INewsletterSubscriberModel => {
	const {
		client_id,
		has_client_account,
		newsletter_marketing_consent,
		granted_at,
		newsletter_removed,
		cio_profile_deleted,
		topics,
		...rest
	} = json

	return {
		...toCamelCase(rest),
		clientID: client_id,
		hasClientAccount: has_client_account,
		newsletterMarketingConsent: newsletter_marketing_consent,
		grantedAt: granted_at ? new Date(granted_at) : null,
		newsletterRemoved: newsletter_removed,
		cioProfileDeleted: cio_profile_deleted,
		topics,
	}
}
